export enum Utility {
	Electric = 0,
	Gas = 10,
	Water = 20
}